import React, { useState, useContext, useEffect } from "react";
import UserContext from "../../../../context/UserContext";
// import Login from '../../../login/Login';
import { useNavigate } from "react-router-dom";
import ExportApi from "../../../../api/ExportApi";
import Login from "../../../../components/Login";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function ProductItem({
  brand,
  thumbnail,
  title,
  series,
  model,
  price,
  id,
  slug,
  data,
  chipset,
  condition,
  layout = "grid",
  heighestBid = 0
}) {
  const {
    selectedProducts,
    setSelectedProducts,
    newlySelectedProducts,
    setNewlySelectedProducts,
  } = useContext(UserContext);
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();
  const userId = JSON.parse(localStorage.getItem("tokenuser"))?.id;

  const [openModal, setOpenModal] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [signup, setSignup] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState({
    popUp: false,
    id: null,
  });

  // const [show, setShow] = useState(false);

  // Adding Products in newlySelectedProducts state
  useEffect(() => {
    setIsClicked(
      newlySelectedProducts?.some((product) => product?._id === data?._id)
    );
  }, [newlySelectedProducts, data?._id]);

  // Add products in Favourite
  const handleClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!userId) {
      setOpenModal(true);
      return;
    }
    if (userId) {
      setIsClicked(!isClicked);
      if (isClicked === false) {
        ExportApi.AddtoFevreat(id, userId)
          // axios.post(ExportApi + `user/addtofav/${userId}`, {
          //   productId: id
          // }, {
          //   headers: {
          //     Authorization: `Bearer ${token}`
          //   }
          // },)
          .then(function (response) {
            setIsClicked(true);
            ExportApi.favouriteList(userId)
              // axios.get(ExportApi + `user/fav/list/${userId}`, {
              //   headers: {
              //     Authorization: `Bearer ${token}`
              //   },
              // })
              .then(function (response) {
                setNewlySelectedProducts(response.data.data.favourite);
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        ExportApi.RemovetoFevreat(id, userId)
          //   productId: id
          // }, {
          //   headers: {
          //     Authorization: `Bearer ${token}`
          //   }
          // },)
          .then(function (response) {
            ExportApi.favouriteList(userId)
              //   headers: {
              //     Authorization: `Bearer ${token}`
              //   },
              // })
              .then(function (response) {
                setNewlySelectedProducts(response?.data?.data?.favourite);
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    } else {
      setOpenModal(true);
    }
  };

  const handleProductClick = (e) => {
    e.preventDefault();
    navigate(`/product/${slug}`);
  };

  useEffect(() => {
    if (selectedProducts?.length > 0) {
      localStorage.setItem("Compare", JSON.stringify(selectedProducts));
    }
  }, [selectedProducts]);
  // Add Products to Compare
  const handleCheckboxChange = () => {
    const isSelected = selectedProducts.some(
      (product) => product._id === data._id
    );

    if (isSelected) {
      setSelectedProducts((prevProducts) =>
        prevProducts.filter((product) => product._id !== data._id)
      );
    } else {
      setSelectedProducts([...selectedProducts, data]);
    }
  };

  // Close Login Modal
  const handleCloseModal = () => {
    setTimeout(() => {
      setOpenModal(false);
    }, 300);
  };

  // Favourite svg style
  const svgStyle = {
    width: "20px",
    height: "20px",
    fill: isClicked ? "red" : "transparent",
    stroke: "black",
    strokeWidth: isClicked ? "0" : 1,
    cursor: "pointer",
  };

  // Function to handle closing a component or dialog
  const handleClose = () => setOpenModal(false);

  const wrapperClass =
    layout === "carousel"
      ? "product-carousel-item position-relative px-0 mx-0"
      : "mb-3 col-6 col-md-4 col-xl-2 position-relative d-flex px-0 mx-0";

  const imageWrapperClass =
    layout === "carousel"
      ? "product-image-wrapper product-image-wrapper--carousel px-0"
      : "product-image-wrapper";

  const handleMouseLeave = () => {
    setTooltipVisible({
      ...tooltipVisible,
      popUp: false,
      id: null,
    });
  };

  const handleMouseEnter = (id) => {
    console.log(id, "iddddddddddddd-----mmm")
    setTooltipVisible({
      ...tooltipVisible,
      popUp: true,
      id: id,
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="bid-ask-tooltip" {...props}>
      <div style={{ fontSize: "13px", lineHeight: "1.6", maxWidth: "220px" }}>
        <p className="tool-tip-content" style={{ position: "relative", color: "#fff", margin: 0, fontSize: "13px", lineHeight: "1.6" }}>
          Make an offer at your price. It’s free, you can cancel/delete offers anytime, and you’re only charged if your offer is accepted.
        </p>
      </div>
    </Tooltip>
  );

  return (
    <div className={wrapperClass} key={id}>
      <div onClick={(e) => {
        e.stopPropagation();
      }} style={{ padding: "10px" }} className="product-box p-3 position-relative w-100" >
        <span
          className="d-flex position-absolute"
          style={{
            color:
              chipset === "AMD"
                ? "rgba(153, 0, 0, 0.5)"
                : chipset === "Nvidia"
                  ? "rgba(0, 102, 0, 0.5)"
                  : "inherit",
            zIndex: 10,
            pointerEvents: 'none'
          }}
        >
          {chipset}
        </span>


     <div className="product-body mt-2 mt-xl-3 w-100">
          <div className="product-body-child">
            <div className={`${imageWrapperClass} `} onClick={(e) => handleProductClick(e)}>
            <img src={thumbnail[0]} alt="thumbnail" />
          </div>
          <div className="product-content">
            <div className="product-details w-100">
              <div className="desc" onClick={(e) => handleProductClick(e)}>

                <p className="text-start mb-0 !min-h-0 product-title-with-icon">
                  <svg
                    viewBox="0 0 17 17"
                    className="sc-beqWaB ixusxy hear-icon hear-icon-mobile"
                    xmlns="http://www.w3.org/2000/svg"
                    style={svgStyle}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleClick(e);
                    }}
                    onTouchStart={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleClick(e);
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
                    ></path>
                  </svg>
                </p>
                <p className="text-start mb-0">
                  <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{brand}</span>
                </p>
                <p className="text-start mb-0">
                  <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{series}</span>
                </p>
                <p className="text-start mb-0"
                  style={{
                    fontWeight: 'normal',
                    fontSize: '12.6px',
                    lineHeight: '12.6px',
                    height: '2.4em',
                    whiteSpace: 'normal',
                    overflow: 'hidden',
                    marginTop: '5px'
                  }}>
                  {model}

                </p>
                <p className="text-start fw-bold condition" style={{ color: '#0b4068', fontSize: '12.6px', lineHeight: '12.6px' }}>
                  Condition:{" "}
                  {condition === 1
                    ? "New-Retail"
                    : condition === 2
                      ? "New"
                      : "Used"}
                </p>
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <div className="d-flex flex-column align-items-start justify-content-start w-100">
                    {
                      price != "TBD" ? (
                        <>
                          <h5 className="fw-bold product-price mb-0">
                            {price == "TBD" ? "-" : "$" + price}
                          </h5>
                          <span style={{ fontSize: "11px", color: "gray" }}>Lowest Ask</span></>
                      ) : (
                        <span style={{ fontSize: "15px", color: "gray" }}>Buy Now -</span>
                      )
                    }

                  </div>
                  <div
                    className="compare d-flex flex-column align-items-end justify-content-end"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >


                     <span style={{ fontSize: "11px", color: "gray" }}> Highest Offer {heighestBid && heighestBid != 0 && heighestBid != "" ? `-$${heighestBid}` : "-"}</span>
                    <div
                      className="askbidbtn rounded mb-0 my-1 d-flex align-items-center"
                      // onClick={() => navigate(`/bidask/${slug}`)}
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(`/bidask/${slug}`, "_blank")
                      }}
                      style={{ position: "relative" }}
                    >
                      Make Offer

                      <OverlayTrigger
                        placement="top"
                        overlay={renderTooltip}
                        container={document.body}
                        trigger={["hover", "focus"]}
                      >
                        <span
                          className="question_mark ms-1"
                          onClick={(e) => e.stopPropagation()}
                          style={{ display: "inline-flex", cursor: "pointer" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="app-best-deal"
                            width="16"
                            height="16"
                            fillRule="currentColor"
                            className="bi bi-question-circle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
                          </svg>
                        </span>
                      </OverlayTrigger>
                    </div>

                    <input
                      type="checkbox"
                      id={`compare-${data._id}`}
                      checked={selectedProducts.some(
                        (product) => product._id === data._id
                      )}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleCheckboxChange();
                      }}
                    />
                  </div>
                </div>
              </div>
              <svg
                viewBox="0 0 17 17"
                className="sc-beqWaB ixusxy hear-icon hear-icon-desktop"
                xmlns="http://www.w3.org/2000/svg"
                style={svgStyle}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleClick(e);
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
                ></path>
              </svg>
            </div>
          </div>
          </div>
        </div>
      </div>
      {openModal && (
        <>
          {/* Login PopUp Start */}
          <Login
            setSignup={setSignup}
            setForgot={setForgot}
            signup={signup}
            forgot={forgot}
            modal={() => handleClose()}
            show={openModal}
            setShow={setOpenModal} />
          {/* Login Popup End */}

        </>
      )}
    </div>
  );
}
